import t from "@/lang/lang";
import { Card, CardContent } from "@/shared/components/ui/card";
import { Offer } from "@/services/backend/omni/offer/types/offer";
import { OfferScopeOfWorkPositionsTable } from "./offer-scope-of-work-positions-table";
import { OfferScopeOfWorkToolbar } from "@/services/backend/omni/offer/components/offer-scope-of-work-toolbar";
import { wrhOfferScopeOfWorkAddDialogConfig } from "@/services/backend/omni/servicekindrules/wrh-offer-scope-of-work-add-dialog-config";
import { useSelectedScopeOfWorkFromSearchParams } from "@/services/backend/omni/scope-of-work/hooks/use-selected-scope-of-work-from-search-params";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { OfferContractForServiceVariation } from "./offer-contract-for-service-variation";

export function OfferPositionsPage({ offer }: { offer: Offer }) {
  const disabled = isImmutable(offer);
  const { selectedId, select, selected } =
    useSelectedScopeOfWorkFromSearchParams(offer.scopeOfWork);

  return (
    <div className="grid grid-cols-1 gap-2">
      <OfferScopeOfWorkToolbar
        offer={offer}
        addDialogConfig={wrhOfferScopeOfWorkAddDialogConfig}
        selectedId={selectedId}
        onSelect={select}
        deleteDescription={t(
          "Die Leistung wird mit allen Positionen und ihrem Vertrag gelöscht. Dies kann nicht rückgängig gemacht werden.",
        )}
        disabled={disabled}
      />
      {selected ? (
        <div className="grid grid-cols-1 gap-2" key={selected.id}>
          <OfferScopeOfWorkPositionsTable
            offer={offer}
            scopeOfWork={selected}
          />
          <OfferContractForServiceVariation
            offer={offer}
            serviceVariation={selected.serviceVariation}
          />
        </div>
      ) : (
        <Card>
          <CardContent className="text-muted-foreground py-6 text-center text-sm">
            {t("Noch keine Leistungen. Fügen Sie eine Leistung hinzu.")}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
